class BeautyHotspots extends window.BAO.CustomElement() {
  initialize () {
    super.initialize()

    if (!window.BAO.MediaBreakpoints.isMd) {
      this.handleClose()
    }
  }

  setupListeners () {
    this.els.spot.elements.forEach((spot) => {
      this.listeners.add(spot, 'click', this.handleHotSpotClick.bind(this))
    })

    this.els.close.elements.forEach((close) => {
      this.listeners.add(close, 'click', this.handleClose.bind(this))
    })

    this.debouncedResize = window.BAO.Utils.debounce((e) => {
      this.resetSize()
    }, 50)
    this.listeners.add(window, 'resize', this.debouncedResize)
  }

  handleHotSpotClick (e) {
    const target = e.target

    this.els.product.elements.forEach((product) => {
      product.ariaHidden =
        product.dataset.index !== target.dataset.productIndex
    })

    this.els.spot.elements.forEach((el) => {
      el.ariaCurrent = el.dataset.productIndex === target.dataset.productIndex
    })

    this.els.products.element.setAttribute('aria-active', true)

    if (!window.BAO.MediaBreakpoints.isMd) {
      this.observer = new IntersectionObserver(this.observerCallback, {
        threshold: 0,
      })

      this.observer.observe(this)
      this.handleResize(target)
    }
  }

  handleResize (target) {
    const elementToBaseOff = this.els.product.elements.find(
      (product) => product.dataset.index === target.dataset.productIndex,
    )
    const elementContentHeight =
      window.BAO.Utils.getElement(this.els.content?.selector, {
        context: elementToBaseOff,
      }).clientHeight + 60

    this.els.products.element.style.height = `${elementContentHeight}px`
  }

  resetSize () {
    if (window.BAO.MediaBreakpoints.isMd) {
      this.els.products.element.removeAttribute('style')
    }
  }

  observerCallback (entries, observer) {
    const isIntersecting = entries.some((entry) => entry.isIntersecting)

    if (!isIntersecting) {
      this.handleClose()
      observer.disconnect()
    }
  }

  handleClose () {
    this.els.products.element.setAttribute('aria-active', false)

    this.els.spot.elements.forEach((el) => {
      el.ariaCurrent = false
    })
  }
}

if (!customElements.get('beauty-hotspots')) {
  customElements.define('beauty-hotspots', BeautyHotspots)
}
